<template>
  <div class="overlay-holder">
    <template v-if="showing">
      <video controls class="full-video" ref="media" muted :loop="loop">
        <source :src="fullUrl" type="video/mp4" />
      </video>
      <div class="artist-overlay" :class="{hidden: !showOverlay}">
        <div class="artist-name">
          <ix-router-link :to="'/artists/' + currentArtist.portfolio_url">{{ currentArtist.formatted_name }}</ix-router-link> &nbsp;
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
    artistLinks: Array,
    autoplay: Boolean,
    loop: Boolean
  },
  computed: {
    fullUrl () {
      if(this.url) {
        return this.$k.imagebase + this.url
      }
      return ''
    }
  },
  data () {
    return {
      media: null,
      showOverlay: false,
      currentArtist: { },
      showing: true
    }
  },
  mounted () {
    this.mountMedia()
  },
  beforeDestroy () {
    if(this.media) {
      this.media.removeEventListener('timeupdate', this.checkTime);
      this.media.removeEventListener('canplay', this.checkPlay)
    }
  },
  methods: {
    mountMedia () {
      this.media = this.$refs.media
      this.media.addEventListener('timeupdate', this.checkTime);
      this.media.addEventListener('canplay', this.checkPlay)
    },
    checkPlay: async function () {
      if(this.autoplay) {
        this.media.play()
        this.media.removeEventListener('canplay', this.checkPlay)
      }
    },
    checkTime: async function () {
      let t = this.media.currentTime
      if(this.artistLinks) {
        for(let each of this.artistLinks) {

          if((t > each.start) && (t < each.end)){
            if(this.currentArtist.portfolio_url !== each.portfolio_url) {
              this.changeArtist(each)
              return
            }
            return
          }
        }
      }
      this.showOverlay = false
    },
    changeArtist: async function (item) {
      let na = await this.$store.dispatch('fetchArtist', item.portfolio_url)
      if(na) {
        this.showOverlay = true
        this.currentArtist = na
      }
    }
  },
  watch: {
    url () {
      this.showing = false
      this.$nextTick(() => {
        // have to clear the old one out of html or it just won't end
        this.showing = true
        this.$nextTick(() => {
          this.mountMedia()
        })
        
      })
    },
    '$store.state.stopPreviews': function () {
      if(this.media) {
        if(this.$store.state.stopPreviews) {
          this.media.pause()
        }
        else {
          if(this.autoplay) {
            this.media.play()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.overlay-holder{
  position:relative;
  overflow:hidden;
}

.artist-overlay{
  z-index:40;
  background-color:rgba(255,255,255,0.6);
  color:#ce0e2d;
  font-size:24px;
  padding:16px 24px;
  bottom:10%;
  right:0;
  position:absolute;
  transition:all 0.3s ease-in
}

.artist-overlay.hidden{
  transform: translateX(100%);
}

.artist-name{
  font-weight:500;
}
</style>
